import { TSerializableAppState } from '../../../shared/types/appState';

export const prepareClientState = (initialState: TSerializableAppState) => {
  if (initialState.chatWindow) {
    initialState.chatWindow.messagesMap = new Map(initialState.chatWindow.serealizebleMap);
  }

  return initialState;
};
